import type {RegistrationStep} from 'modules/VendorRegister/types';

type RegistrationStepperProps = {
  currentStep?: RegistrationStep;
  selectedStepNumber?: number;
  steps: RegistrationStep[];
};

const RegistrationStepper: React.FC<RegistrationStepperProps> = ({
  currentStep,
  selectedStepNumber,
  steps
}) => {
  return (
    <div className="overflow-x-auto">
      <div className="flex min-w-max items-end px-4 py-3">
        {steps.map((step) => {
          if (currentStep && step.no < currentStep.no) {
            return null;
          }

          const isActive = step.no === selectedStepNumber;

          return (
            <div
              className={`flex items-end ${isActive ? 'opacity-100' : 'opacity-50'}`}
              key={step.value}
            >
              <div className="mx-1.5 flex flex-col items-center justify-center">
                <span className="flex size-6.5 items-center justify-center rounded-full border border-neutral-fg text-body-xs-emphasis text-neutral-fg">
                  {step.no}
                </span>
                <span className="mt-1.5 whitespace-nowrap text-body-xs text-neutral-fg">
                  {step.title}
                </span>
              </div>
              <span className="mb-2 h-px w-6.5 border-t border-dashed border-gray-06" aria-hidden />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegistrationStepper;
